import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock, FiHeart, FiLeaf, FiFilter } = FiIcons;

function MenuPage() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [dietaryFilter, setDietaryFilter] = useState('all');

  const categories = [
    { id: 'all', name: 'All Items' },
    { id: 'breakfast', name: 'Breakfast' },
    { id: 'rice-curry', name: 'Rice & Curry' },
    { id: 'kottu', name: 'Kottu & Fried Rice' },
    { id: 'beverages', name: 'Beverages' },
    { id: 'snacks', name: 'Snacks' }
  ];

  const dietaryFilters = [
    { id: 'all', name: 'All' },
    { id: 'halal', name: 'Halal' },
    { id: 'vegan', name: 'Vegan' },
    { id: 'vegetarian', name: 'Vegetarian' }
  ];

  const menuItems = [
    // Breakfast
    {
      id: 1,
      name: 'Packer\'s Breakfast',
      category: 'breakfast',
      price: 600,
      description: 'Pre-ordered packed meal perfect for early morning treks. Includes sandwiches, boiled eggs, fresh fruit, and juice.',
      dietary: ['halal', 'vegetarian'],
      image: 'https://images.unsplash.com/photo-1551782450-17144efb9c50?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 2,
      name: 'Sri Lankan Breakfast',
      category: 'breakfast',
      price: 800,
      description: 'Traditional string hoppers with coconut sambol, dhal curry, and seeni sambol.',
      dietary: ['halal', 'vegan'],
      image: 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    // Rice & Curry
    {
      id: 3,
      name: 'Village Rice & Curry',
      category: 'rice-curry',
      price: 1200,
      description: 'Authentic rice and curry with 6-8 vegetable sides, papadam, and pickle. Slow-cooked in traditional clay pots.',
      dietary: ['halal', 'vegetarian'],
      image: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 4,
      name: 'Chicken Curry Rice',
      category: 'rice-curry',
      price: 1500,
      description: 'Village-style chicken curry with red rice, coconut sambol, and seasonal vegetables.',
      dietary: ['halal'],
      image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 5,
      name: 'Fish Curry Rice',
      category: 'rice-curry',
      price: 1400,
      description: 'Fresh fish curry with coconut milk, served with steamed rice and traditional accompaniments.',
      dietary: ['halal'],
      image: 'https://images.unsplash.com/photo-1563379091339-03246963d73a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    // Kottu & Fried Rice
    {
      id: 6,
      name: 'Chicken Kottu',
      category: 'kottu',
      price: 900,
      description: 'Freshly chopped roti stir-fried with chicken, vegetables, and aromatic spices.',
      dietary: ['halal'],
      image: 'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 7,
      name: 'Vegetable Kottu',
      category: 'kottu',
      price: 700,
      description: 'Mixed vegetable kottu with carrots, cabbage, leeks, and spices.',
      dietary: ['halal', 'vegan', 'vegetarian'],
      image: 'https://images.unsplash.com/photo-1565299507177-b0ac66763828?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 8,
      name: 'Chicken Fried Rice',
      category: 'kottu',
      price: 850,
      description: 'Fragrant basmati rice wok-fried with chicken, vegetables, and soy sauce.',
      dietary: ['halal'],
      image: 'https://images.unsplash.com/photo-1512058564366-18510be2db19?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    // Beverages
    {
      id: 9,
      name: 'Ceylon Tea',
      category: 'beverages',
      price: 150,
      description: 'Fresh Ceylon black tea from local Kolonna estates.',
      dietary: ['halal', 'vegan', 'vegetarian'],
      image: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 10,
      name: 'Fresh King Coconut',
      category: 'beverages',
      price: 200,
      description: 'Refreshing natural coconut water straight from the shell.',
      dietary: ['halal', 'vegan', 'vegetarian'],
      image: 'https://images.unsplash.com/photo-1447933601403-0c6688de566e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    // Snacks
    {
      id: 11,
      name: 'Isso Vadei',
      category: 'snacks',
      price: 400,
      description: 'Crispy prawn fritters with spices and curry leaves (4 pieces).',
      dietary: ['halal'],
      image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 12,
      name: 'Pol Roti',
      category: 'snacks',
      price: 300,
      description: 'Traditional coconut roti served with lunu miris (chili paste).',
      dietary: ['halal', 'vegan', 'vegetarian'],
      image: 'https://images.unsplash.com/photo-1596797038530-2c107229654b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    }
  ];

  const filteredItems = menuItems.filter(item => {
    const categoryMatch = activeCategory === 'all' || item.category === activeCategory;
    const dietaryMatch = dietaryFilter === 'all' || item.dietary.includes(dietaryFilter);
    return categoryMatch && dietaryMatch;
  });

  const getDietaryBadges = (dietary) => {
    return dietary.map(diet => {
      const colors = {
        halal: 'bg-green-500/20 text-green-400',
        vegan: 'bg-emerald-500/20 text-emerald-400',
        vegetarian: 'bg-yellow-500/20 text-yellow-400'
      };
      return { name: diet, color: colors[diet] };
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-900 pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6">
            Our <span className="gradient-text">Menu</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">
            Authentic Sri Lankan flavors prepared fresh in our halal-certified kitchen. 
            From traditional rice and curry to modern favorites.
          </p>

          {/* Kitchen Hours */}
          <div className="glass-morphism rounded-xl p-4 inline-flex items-center space-x-2">
            <SafeIcon icon={FiClock} className="w-5 h-5 text-emerald-400" />
            <span className="text-white font-medium">Kitchen Hours: 5:30 AM - 10:00 PM</span>
          </div>
        </motion.div>

        {/* Filters */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="mb-12"
        >
          <div className="glass-morphism rounded-2xl p-6">
            <div className="grid md:grid-cols-2 gap-6">
              {/* Category Filter */}
              <div>
                <h3 className="text-lg font-semibold text-white mb-4 flex items-center">
                  <SafeIcon icon={FiFilter} className="w-5 h-5 mr-2 text-emerald-400" />
                  Categories
                </h3>
                <div className="flex flex-wrap gap-2">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setActiveCategory(category.id)}
                      className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                        activeCategory === category.id
                          ? 'bg-emerald-600 text-white'
                          : 'bg-white/10 text-gray-300 hover:bg-white/20'
                      }`}
                    >
                      {category.name}
                    </button>
                  ))}
                </div>
              </div>

              {/* Dietary Filter */}
              <div>
                <h3 className="text-lg font-semibold text-white mb-4 flex items-center">
                  <SafeIcon icon={FiLeaf} className="w-5 h-5 mr-2 text-emerald-400" />
                  Dietary Options
                </h3>
                <div className="flex flex-wrap gap-2">
                  {dietaryFilters.map((filter) => (
                    <button
                      key={filter.id}
                      onClick={() => setDietaryFilter(filter.id)}
                      className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                        dietaryFilter === filter.id
                          ? 'bg-emerald-600 text-white'
                          : 'bg-white/10 text-gray-300 hover:bg-white/20'
                      }`}
                    >
                      {filter.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Menu Items Grid */}
        <motion.div
          layout
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12"
        >
          {filteredItems.map((item, index) => (
            <motion.div
              key={item.id}
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              whileHover={{ scale: 1.03, transition: { duration: 0.3 } }}
              className="glass-morphism rounded-2xl overflow-hidden hover:glass-morphism-dark transition-all duration-300"
            >
              {/* Food Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                />
                <div className="absolute top-4 right-4">
                  <span className="bg-emerald-500 px-3 py-1 rounded-full text-sm font-bold text-white">
                    LKR {item.price}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-serif font-bold text-white mb-2">{item.name}</h3>
                <p className="text-gray-300 mb-4 text-sm leading-relaxed">{item.description}</p>
                
                {/* Dietary Badges */}
                <div className="flex flex-wrap gap-2">
                  {getDietaryBadges(item.dietary).map((badge) => (
                    <span
                      key={badge.name}
                      className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${badge.color}`}
                    >
                      {badge.name}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* WhatsApp Order CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="glass-morphism rounded-2xl p-8 text-center"
        >
          <SafeIcon icon={FiHeart} className="w-12 h-12 text-emerald-400 mx-auto mb-6" />
          <h3 className="text-2xl font-serif font-bold text-white mb-4">
            Ready to Order?
          </h3>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
            Pre-order your meals via WhatsApp for faster service. Perfect for early morning departures 
            or when you want your food ready upon arrival.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/94771234567?text=Hi! I'd like to order from the menu."
              target="_blank"
              rel="noopener noreferrer"
              className="liquid-button bg-green-600 hover:bg-green-700 text-white font-semibold py-4 px-8 rounded-xl transition-all duration-300 flex items-center justify-center space-x-2"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488z"/>
              </svg>
              <span>Order via WhatsApp</span>
            </a>
            <a
              href="tel:+94771234567"
              className="border-2 border-emerald-400 text-emerald-400 hover:bg-emerald-400 hover:text-white font-semibold py-4 px-8 rounded-xl transition-all duration-300"
            >
              Call to Order
            </a>
          </div>

          <div className="mt-6 text-sm text-gray-400">
            <p>Pre-orders accepted until 9:00 PM • Delivery available within Kolonna town</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default MenuPage;